import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <SectionWrapper className="text-center" data-id="element-27">
      <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-8" data-id="element-28">
        El Protocolo Vientre Plano 40+
      </h2>
      <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto" data-id="element-29">
        Desinflama tu abdomen hormonal en 7 días. Haz clic para obtener acceso
        instantáneo y comenzar tu reseteo.
      </p>
      <div className="flex items-baseline justify-center gap-3 mb-6" data-id="element-30">
        <span className="text-xl md:text-2xl text-gray-400 line-through font-semibold" data-id="element-31">
          $27
        </span>
        <span className="text-4xl md:text-5xl font-bold text-coral" data-id="element-32">
          $6.39 <span className="text-xl text-gray-500" data-id="element-33">USD</span>
        </span>
      </div>
      <CTAButton data-id="element-34">¡SÍ, QUIERO MI VIENTRE PLANO 40+ AHORA!</CTAButton>
      <p className="text-sm text-gray-500 font-medium mt-4" data-id="element-35">
        Pago único · Acceso de por vida
      </p>
    </SectionWrapper>;
}